import React from "react";

import { Label } from "@fronterahealth/frontera-ui-components";

import { EhrChildCollectionPartsFragment } from "@api/graphql/types-and-hooks";
import { EhrStoredRowTable } from "@pages/ClientEhrProgramming/EhrStoredRowTable";

interface EhrChildCollectionSectionProps {
  collection: EhrChildCollectionPartsFragment;
}

// A child table of a goal or target, e.g. its phase history or events.
export const EhrChildCollectionSection: React.FC<EhrChildCollectionSectionProps> = ({ collection }) => {
  return (
    <details className="rounded-md border border-limestone-100 px-4 py-3">
      <summary className="cursor-pointer">
        <Label size="small">
          {collection.label} ({collection.rows.length})
        </Label>
      </summary>
      <div className="pt-3">
        <EhrStoredRowTable
          rows={collection.rows.map((row, index) => ({ id: `${collection.key}-${index}`, fields: row.fields }))}
        />
      </div>
    </details>
  );
};
